import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '@sm360/widget-commons-vehicle';

import InstantEstimateProvider from 'trade-in-360/InstantEstimateProvider.jsx';

// CBB autocomplete black box
const TradeInBarWrapper = (props) => {
    const { style, organizationUnitId } = props;

    return (
        <div id="instant-estimate-bar-wrapper" style={style}>
            <InstantEstimateProvider {...props} isModal organizationUnitId={organizationUnitId} />
        </div>
    );
};

TradeInBarWrapper.defaultProps = {
    style: {},
    isShowroomV2Enabled: false,
    quote: undefined,
    organizationUnitId: 0,
    isBarWrapper: false,
};

TradeInBarWrapper.propTypes = {
    style: PropTypes.objectOf(PropTypes.string),
    isShowroomV2Enabled: PropTypes.bool,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    organizationUnitId: PropTypes.number,
    isBarWrapper: PropTypes.bool,
};

TradeInBarWrapper.displayName = 'TradeInBarWrapper';

export default TradeInBarWrapper;
